import {numberFormat} from "@src/common/service/numberFormatHelper";

/**
 * 絞り込み条件を検索履歴のパネルに表示する形式に整形する
 *
 * @param {SearchParam} searchParam
 * @param {FilteringDefinitions} filterDefinitions
 * @param translations
 * @return {string}
 */
export const combineFilterParams = (searchParam, filterDefinitions, translations = {}) => {
    let distanceExpression = '';
    let salaryTypeValue = '';
    let salaryAmountExpression = '';
    let salaryExpression = '';
    let jobTypeExpression = '';
    let featuresExpression = '';
    let datePostedExpression = '';

    if (filterDefinitions === null || filterDefinitions === undefined) {
        return '';
    }

    if (searchParam.distance.length > 0) {
        distanceExpression = filterDefinitions.distanceDefinition[searchParam.distance];
    }

    if (searchParam.salaryType.length > 0) {
        const currency = translations.salary_currency || '$';

        const salaryMin = searchParam.salaryMin.includes('.') ? numberFormat(searchParam.salaryMin, 1) : numberFormat(searchParam.salaryMin, 0);
        const salaryMax = searchParam.salaryMax.includes('.') ? numberFormat(searchParam.salaryMax, 1) : numberFormat(searchParam.salaryMax, 0);

        if (searchParam.salaryMin.length > 0 && searchParam.salaryMax > 0) {
            salaryAmountExpression = `: ${currency}${salaryMin}-${currency}${salaryMax}`;
        } else if (searchParam.salaryMin.length > 0) {
            salaryAmountExpression = `: ${currency}${salaryMin}-`;
        } else if (searchParam.salaryMax > 0) {
            salaryAmountExpression = `: -${currency}${salaryMax}`;
        }


        salaryTypeValue = filterDefinitions.salaryTypeDefinition[searchParam.salaryType];

        salaryExpression = ' / ' + salaryTypeValue + salaryAmountExpression;
    }
    if (searchParam.jobType.length > 0) {
        jobTypeExpression = ' / ' + filterDefinitions.jobTypeDefinition[searchParam.jobType];
    }
    if (searchParam.features.length > 0) {
        featuresExpression = searchParam.features.reduce((previousValue, currentValue) => {
            return previousValue + ' / ' + filterDefinitions.featureDefinition[currentValue];
        }, '');
    }
    if (searchParam.datePosted.length > 0) {
        datePostedExpression = ' / ' + filterDefinitions.datePostedDefinition[searchParam.datePosted];
    }

    return (
        distanceExpression
        + salaryExpression
        + jobTypeExpression
        + featuresExpression
        + datePostedExpression
    ).replace(/^ \/ /, '');
}
